export interface TeamMember {
  name: string
  title: string
  bio: string
  image?: string
}

export const BOARD_OF_DIRECTORS: TeamMember[] = [
  {
    name: 'Professor John Humphrey',
    title: 'Chairman',
    image: '/assets/leadership/john-humphrey.png',
    bio: 'Expert in mergers and acquisitions, corporate finance and governance. Former Dean of Law at QUT and Senior Partner at King & Wood Mallesons. Experienced Chair across resources, banking and professional services.',
  },
  {
    name: 'Amanda Lacaze',
    title: 'Managing Director',
    image: '/assets/leadership/amanda-lacaze.png',
    bio: 'CEO since 2014 with over 25 years of senior operational experience. Former CEO of Commander Communications and Telstra Marketing MD. Board member of the Minerals Council of Australia and Chief Executive Women.',
  },
  {
    name: 'John Beevers',
    title: 'Non-Executive Director',
    image: '/assets/leadership/john-beevers.png',
    bio: 'Over 30 years in resources, mining services and chemicals. Former CEO of Orica Mining Services and Managing Director of Groundprobe. Non-Executive Director of Orica Limited and Syrah Resources.',
  },
  {
    name: 'Philippe Etienne',
    title: 'Non-Executive Director',
    image: '/assets/leadership/philippe-etienne.png',
    bio: 'Chair of Cleanaway Waste Management and Director of Aristocrat Leisure. Former CEO of Orica Mining Services and Innovia Security. Chair of the Health, Safety and Environment Committee.',
  },
  {
    name: 'Dr Vanessa Guthrie AO',
    title: 'Non-Executive Director',
    image: '/assets/leadership/vanessa-guthrie.png',
    bio: '30+ years in resources across operations, sustainability and indigenous affairs. Deputy Chair of Cricket Australia, Chancellor of Curtin University. Officer of the Order of Australia for contribution to minerals sector.',
  },
  {
    name: 'Grant Murdoch',
    title: 'Non-Executive Director',
    image: '/assets/leadership/grant-murdoch.png',
    bio: '38 years of chartered accounting experience. Former corporate finance lead at EY Queensland and Deloitte partner. Chair of the Audit, Risk and ESG Committee. Master of Commerce from University of Canterbury.',
  },
  {
    name: 'Kathleen Bozanic',
    title: 'Non-Executive Director',
    image: '/assets/leadership/kathleen-bozanic.png',
    bio: '30+ years as a finance professional in resources. Former CFO and Audit Chair of IGO Ltd, Deloitte partner. Non-Executive Chair of WA1 Resources and Director of Rugby Australia.',
  },
]

export const SENIOR_MANAGEMENT: TeamMember[] = [
  {
    name: 'Gaudenz Sturzenegger',
    title: 'Chief Financial Officer',
    image: '/assets/leadership/gaudenz-sturzenegger.png',
    bio: 'Joined Lynas in 2014. Former CFO of General Motors India with extensive experience across Europe and Asia. MBA from University of St Gallen. Leads finance, procurement and IT.',
  },
  {
    name: 'Pol Le Roux',
    title: 'Chief Operating Officer',
    image: '/assets/leadership/pol-le-roux.png',
    bio: 'Leads Lynas\' full operations from Mt Weld to Malaysia. 26 years with Rhodia/Solvay. Drives sustainability initiatives including Life Cycle Analysis and mine-to-magnet traceability.',
  },
  {
    name: 'Dato Sri Mashal Ahmad',
    title: 'Vice President Malaysia',
    image: '/assets/leadership/dato-sri-mashal-ahmad.png',
    bio: 'Established Lynas Malaysia operations in 2008. 35+ years in chemical, LNG and rare earth industries with ICI, Eastman and PETRONAS. Conferred Darjah Indera Mahkota Pahang in 2010.',
  },
  {
    name: 'Mimi Afzan Afza',
    title: 'Vice President People & Culture',
    image: '/assets/leadership/mimi-afzan-afza.png',
    bio: 'Joined Lynas in 2008. Leads talent, culture and organisational development. Experience across manufacturing and resources. Master of Management from Malaysia Putra University.',
  },
  {
    name: 'Daniel Havas',
    title: 'Vice President Strategy & Investor Relations',
    image: '/assets/leadership/daniel-havas.png',
    bio: 'Leads strategic planning, investor relations and government engagement. Former Austrade Senior Trade Commissioner to Malaysia & Brunei. Strong background in international business strategy.',
  },
  {
    name: 'Jennifer Parker',
    title: 'Vice President Corporate Affairs',
    image: '/assets/leadership/jennifer-parker.png',
    bio: 'Leads communications and ESG impact. 15+ years in corporate affairs including REA Group and Cannings. Master of Arts Communications Management from UTS.',
  },
  {
    name: 'Sarah Leonard',
    title: 'General Counsel and Company Secretary',
    image: '/assets/leadership/sarah-leonard.png',
    bio: 'Leading resources and infrastructure lawyer. Former Group Legal Counsel at Monadelphous and partner at Corrs Chambers Westgarth. Responsible for governance, compliance and regulatory matters.',
  },
  {
    name: 'Chris Jenney',
    title: 'Vice President Sales & Market Development',
    image: '/assets/leadership/chris-jenney.png',
    bio: 'Leads sales, marketing and downstream partnerships. 25+ years in industrial, technology and media across Europe, Australia and Asia. Joined Lynas in 2021 as Executive GM Business Development.',
  },
]
